import { BaseEntity, DefaultResponseWithData } from "./system";

export interface IAllMessagesRepsonse extends DefaultResponseWithData<IMessage[]> {}
export interface IUnreadMessageResponse extends DefaultResponseWithData<IUnreadMessages[]> {}

export enum MessageStatus {
  Waiting,
  Accepted,
  Queued,
  Sending,
  Sent,
  Failed,
  Delivered,
  Undelivered,
  Received,
  Read,
}

export interface IUnreadMessages {
  leadId: string;
  unreadMessageCount: number;
}

export interface IMessage extends BaseEntity {
  status: MessageStatus;
  sid: string;
  from: string;
  recipient: string;
  body: string;
  userId: string;
  timestamp: string;

  // A thread is the contact's whole history, so it can contain texts sent from any of their leads.
  // These say which one, so the UI can flag a text that belongs to a different vehicle. Both null
  // for texts sent against the contact rather than a lead.
  leadId: string | null;
  leadVrm: string | null;

  // Empty guid when the system sent it rather than a member of staff.
  sentBy: string;
  isAutomated: boolean;
  templateId: string | null;
  templateName: string | null;
}
